import { reactAppRenderer, getInitialData, setInitialData } from './renderer';
export { getInitialData, setInitialData };
export default reactAppRenderer;
//# sourceMappingURL=index.js.map